import styled from '@emotion/styled'

import { breakpoints, NativeLink, spacing } from 'main/ui'

export const Container = styled.div`
  padding: ${spacing.majorScale(2)}px 0;
`

export const AdditionalInfoContainer = styled.div`
  @media (min-width: ${breakpoints.lg}px) {
    margin: 0 ${spacing.majorScale(2)}px 0 ${spacing.majorScale(5)}px;
  }
`

export const SpaceBetweenFlexSpan = styled.span`
  display: flex;
  flex-direction: column;
  padding-left: 0;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const LinkWithLeftPaddingSometimes = styled(NativeLink)`
  white-space: nowrap;
  padding-left: 0;

  @media (min-width: ${breakpoints.lg}px) {
    padding-left: 1rem;
  }
`
